import { render } from "./popupmodal.vue?vue&type=template&id=baf1d18a&scoped=true"
import script from "./popupmodal.vue?vue&type=script&lang=js"
export * from "./popupmodal.vue?vue&type=script&lang=js"

import "./popupmodal.vue?vue&type=style&index=0&id=baf1d18a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baf1d18a"]])

export default __exports__